import { ReactElement } from 'react'
import { ToggleButton, ToggleButtonProps, Tooltip } from '@mui/material'

export type TooltipToggleButtonProps = ToggleButtonProps & {
  tooltip: string
  tooltipPlacement?: 'bottom' | 'left' | 'right' | 'top'
}

/**
 * Compact text toggle button (for a `ToggleButtonGroup`) with a hover tooltip. The group passes
 * its state through context, so the tooltip wrapper does not interfere with it.
 */
const TooltipToggleButton = ({
  tooltip,
  tooltipPlacement = 'top',
  sx,
  ...buttonProps
}: TooltipToggleButtonProps): ReactElement => (
  <Tooltip title={tooltip} arrow disableInteractive placement={tooltipPlacement}>
    <ToggleButton
      size="small"
      sx={[{ fontSize: 11, textTransform: 'none', py: 0.25 }, ...(Array.isArray(sx) ? sx : [sx])]}
      {...buttonProps}
    />
  </Tooltip>
)

export default TooltipToggleButton
